import { Component, inject } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent as UserFooterComponent } from '../footer/footer.component';
import { FooterComponent as FooterComponent } from '@modules/footer/pages/footer/footer.component';
import { RouterModule } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'market-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    UserFooterComponent,
    RouterModule,
    AsyncPipe,
    FooterComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  isLogin$ = inject(AuthService).login$;
}
